let _ = require('lodash');


// Animate menu items
const mainMenuItems = document.querySelectorAll('.menu--main .inner > ul.menu > li');

let i = 0.2;
mainMenuItems.forEach(menuItem => {
    menuItem.style.transitionDelay = i + 's';

    i += 0.1;
});


// Make whole card clickable
function clickableCard() {
  window.location.href = this.getElementsByTagName('A')[0];
}

(function ($, Drupal) {
    const topicOverviewFunctionalities = () => {
        let lastNewsItems = document.getElementsByClassName('topic-item');

        Array.from(lastNewsItems).forEach(item => {
            let link = item.getElementsByTagName('A')[0];

            if (!_.isNil(link)) {
                item.addEventListener('click', clickableCard, false);
                item.style.cursor = 'pointer';
            }
        });

        // Animate topic filter items
        const topicFilterItems = document.querySelectorAll('#filters .form-item-category');

        i = 0.2;
        topicFilterItems.forEach(topicFilter => {
            topicFilter.style.transitionDelay = i + 's';

            i += 0.2;
        });
    }

    topicOverviewFunctionalities();

    Drupal.behaviors.topicItemOverview = {
        attach: function (context, settings) {
            const classes = [
                'view-topic-overview-with-filters',
                'view-topic-overview',
                'view-topic-overview-garage'
            ];

            if (classes.some(cls => context.classList?.contains(cls))) {
                topicOverviewFunctionalities();
            }
        }
    };
})(jQuery, Drupal);


// Prevent default on video click
let videos = document.getElementsByClassName('vue-iframe-wrapper');

Array.from(videos).forEach(video => {
    let videoLink = video.getElementsByTagName('A')[0];
    if (videoLink) {
        videoLink.style.cursor = 'default';

        videoLink.addEventListener('click', function (event) {
            event.preventDefault();
        });
    }
});


// When clicked on back button go back 1 in history
let backbuttons = document.getElementsByClassName('field--name-dynamic-block-fieldoccasion-entity-back-to-occasions');

Array.from(backbuttons).forEach(backbutton => {
    let link = backbutton.getElementsByTagName('A')[0];

    link.addEventListener('click', function (event) {
        if (document.referrer.indexOf(window.location.host) !== -1) {
            history.go(-1);
            return false;
        }
    });
});


// Shows the contact details of the occasion when scrolled down fixed on the bottom of the page
const header = document.querySelector('.header-title > .container');
const occasionContactDetails = document.querySelector('.field--name-dynamic-block-fieldoccasion-entity-occasion-garage-phone-email');
const options = {
    root: null,
    threshold: 0,
    rootMargin: '0px'
}

const observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach(entry => {

        if (entry.isIntersecting === false) {
            occasionContactDetails.classList.add('visible');
        } else {
            occasionContactDetails.classList.remove('visible');
        }
    })
}, options);


// observer.observe(contactDetails);
if (occasionContactDetails != null) {
    observer.observe(header);
}

// Add active class to audience menu
let audienceMenu = document.querySelector('.block-switch-audience-block');
if (typeof (audienceMenu) != 'undefined' && audienceMenu != null) {
    if (window.location.pathname.includes('garages') || window.location.pathname.includes('garagistes') || window.location.pathname.includes('garagen') || window.location.pathname.includes('garagisten')) {
        audienceMenu.querySelector('.menu li:last-child a').classList.add('is-active');
    } else {
        audienceMenu.querySelector('.menu li:first-child a').classList.add('is-active');
    }
}

// Corrector of backlink for topic detail page
let backLinkTopicPage = document.querySelector('.field--name-dynamic-block-fieldnode-back-to-topic-overview');
if (typeof (backLinkTopicPage) != 'undefined' && backLinkTopicPage != null) {
    let href = backLinkTopicPage.querySelector('.menu li a').getAttribute('href');
    let language = '/' + href.split('/')[1];
    let page = href.split('/')[2];

    if (window.location.pathname.includes('garages')) {
        backLinkTopicPage.querySelector('.menu li a').setAttribute('href', language + '/garages/' + page);
    }

    if (window.location.pathname.includes('garagistes')) {
        backLinkTopicPage.querySelector('.menu li a').setAttribute('href', language + '/garagistes/' + page);
    }

    if (window.location.pathname.includes('garagen')) {
        backLinkTopicPage.querySelector('.menu li a').setAttribute('href', language + '/garagen/' + page);
    }

    if (window.location.pathname.includes('garagisten')) {
        backLinkTopicPage.querySelector('.menu li a').setAttribute('href', language + '/garagisten/' + page);
    }
}

const bodyClassnames = document.body.classList;
const nodeId = Array.from(bodyClassnames).filter(className => className.includes('page-node-'))

switch (nodeId[0]) {
    case 'page-node-76':
        OneTrust.NoticeApi.Initialized.then(function() {
            OneTrust.NoticeApi.LoadNotices(["https://privacyportal-cdn.onetrust.com/9e3840d9-d3d2-4665-ac3b-b1cdce104745/privacy-notices/350986fc-20fd-467a-8e2a-14c1ee152896.json"]);
        });
        break;
    case 'page-node-141':
        OneTrust.NoticeApi.Initialized.then(function() {
            OneTrust.NoticeApi.LoadNotices(["https://privacyportal-cdn.onetrust.com/9e3840d9-d3d2-4665-ac3b-b1cdce104745/privacy-notices/68543441-4981-4d60-b04f-eba65d61969e.json"]);
        });
        break;
    case 'page-node-114':
        OneTrust.NoticeApi.Initialized.then(function() {
            OneTrust.NoticeApi.LoadNotices(["https://privacyportal-cdn.onetrust.com/9e3840d9-d3d2-4665-ac3b-b1cdce104745/privacy-notices/06110ea5-0307-48da-a3c0-844c0892d901.json"]);
        });
        break;
    case 'page-node-153':
        OneTrust.NoticeApi.Initialized.then(function() {
            OneTrust.NoticeApi.LoadNotices(["https://privacyportal-cdn.onetrust.com/9e3840d9-d3d2-4665-ac3b-b1cdce104745/privacy-notices/f30ed2e1-3a08-40f1-8988-226bf5b2822f.json"]);
        });
        break;
    case 'page-node-207':
        OneTrust.NoticeApi.Initialized.then(function() {
            OneTrust.NoticeApi.LoadNotices(["https://privacyportal-cdn.onetrust.com/9e3840d9-d3d2-4665-ac3b-b1cdce104745/privacy-notices/a863cf9a-89c8-465e-94a9-1eed5c384259.json"]);
        });
}
